'use strict'

const union = require('folktale/adt/union/union')

const deriveMethods = require('../adt/deriveMethods')

const Service = union('Service', {
  Null: () => ({}),
  Pending: service => ({ service }),
  Ready: (service, instanceData) => ({
    instance: service(instanceData)
  })
})

deriveMethods(Service, {
  instantiate: {
    Null: function instantiate() {
      return this
    },
    Pending: function instance(instanceData) {
      return Service.Ready(this.service, instanceData)
    },
    Ready: function instantiate() {
      return this
    }
  },

  chain: {
    Null: function chain(fn) {
      return this
    },
    Pending: function chain(fn) {
      return this
    },
    Ready: function chain(fn) {
      return fn(this.instance)
    }
  }
})

module.exports = Service



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/async/service.js